import { IExpenditureType } from '../../types'
import { enumTransformer } from '../../../services/_common/utils'
import {TApiEnums} from '../../../services/_common'

export function parseExpenditureTypes(response: TApiEnums): IExpenditureType[] {
    return response.entities.map(enumTransformer)
}